import {
  UPDATE_SEARCH_TEXT,
  ON_SHOW_LOADING_STATE
} from '../actions.js';

const initialState = {
  searchText: '',
  showLoadingState: false
};

export default (state = initialState, action) => {
  if (action.type === UPDATE_SEARCH_TEXT) {
    return { searchText: action.payload, showLoadingState: false };
  }
  if (action.type === ON_SHOW_LOADING_STATE) {
    return { ...state, showLoadingState: true };
  }

  return state;
};



// WEBPACK FOOTER //
// ./src/modules/codes/reducers/search.js